export var setIsViewOnlyMode = function () {
    return function (dispatch) {
        dispatch({
            type: 'SET_VIEW_ONLY_MODE',
        });
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/ui.actions.ts
// module id = 602
// module chunks = 81